import { c as _c } from "react/compiler-runtime";
import React, { CSSProperties, ReactElement, useState } from 'react';
import { AiLabel } from '@spa/pages-converters/cms/components/convertCmsImage';
import { ImageAiMarkerComponent } from '@spa/components/image-ai-marker/image-ai-marker.component';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './vimeo-player.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly videoId: string;
  readonly previewImageSrc: string | null;
  readonly previewImageAiLabel?: AiLabel | null;
  readonly alt: string;
  readonly height: number;
  readonly width: number;
  readonly autoplay: boolean;
  readonly muted: boolean;
}
export default function VimeoPlayerComponent(t0) {
  const $ = _c(16);
  const {
    videoId,
    previewImageSrc,
    previewImageAiLabel,
    alt,
    height,
    width,
    autoplay,
    muted
  } = t0;
  const videoSrcUrl = new URL(`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&autopause=0`);
  videoSrcUrl.searchParams.set("autoplay", autoplay ? "1" : "0");
  videoSrcUrl.searchParams.set("muted", muted || autoplay ? "1" : "0");
  const initialVideoLoaded = autoplay;
  const [videoLoaded, setVideoLoaded] = useState(initialVideoLoaded);
  const {
    formatMessage
  } = useNamespacedIntl("video-player");
  const {
    formatMessage: formatAiMarkerMessage
  } = useNamespacedIntl("image-ai-marker");
  const previewImageAiLabelEnabled = previewImageAiLabel?.enabled === true;
  let t1;
  if ($[0] !== alt || $[1] !== formatAiMarkerMessage || $[2] !== previewImageAiLabelEnabled) {
    t1 = previewImageAiLabelEnabled && alt ? `${alt}, ${formatAiMarkerMessage("accessibleLabel")}` : alt;
    $[0] = alt;
    $[1] = formatAiMarkerMessage;
    $[2] = previewImageAiLabelEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const previewDisplayAlt = t1;
  let t2;
  if ($[4] !== previewImageAiLabelEnabled) {
    t2 = previewImageAiLabelEnabled ? {
      "data-digital-source-type": "compositeWithTrainedAlgorithmicMedia"
    } : {};
    $[4] = previewImageAiLabelEnabled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const digitalSourceTypeAttr = t2;
  const t3 = `${width}px`;
  const t4 = `${height}px`;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      maxWidth: t3,
      maxHeight: t4
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const wrapperStyle = t5;
  const t6 = styles["vimeo-player"];
  const t7 = styles["vimeo-player__video-frame"];
  const t8 = videoLoaded || !previewImageSrc ? <div className={styles["vimeo-player__iframe-wrapper"]}><iframe className={styles["vimeo-player__iframe"]} src={videoSrcUrl.toString()} width={width} height={height} title={alt} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen={true} sandbox="allow-scripts allow-same-origin allow-presentation" style={{
      backgroundImage: `url(${previewImageSrc})`,
      backgroundSize: "cover"
    }} aria-label={alt} /></div> : <><button className={styles["vimeo-player__preview-wrapper"]} onClick={() => setVideoLoaded(true)} aria-label={formatMessage("play")}><ImageComponent className={styles["vimeo-player__preview"]} src={previewImageSrc} alt={previewDisplayAlt} fill={true} loading="lazy" {...digitalSourceTypeAttr} /><div className={styles["vimeo-player__play-button"]}><ImageComponent src="/assets/icons/play.svg" alt={formatMessage("play")} width={50} height={50} loading="lazy" /></div></button>{previewImageAiLabel && <ImageAiMarkerComponent show={previewImageAiLabel.enabled} position={previewImageAiLabel.position} style={previewImageAiLabel.style} />}</>;
  let t9;
  if ($[9] !== t7 || $[10] !== t8 || $[11] !== wrapperStyle) {
    t9 = <div className={t7} style={wrapperStyle}>{t8}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = wrapperStyle;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <div className={t6}>{t9}</div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}